module.exports = __webpack_public_path__ + "media/images/favicon/favicon-76-0aeab7f048ecf710a1f087042412e69a.png";